"use client";
import PageContainer from "@/app/admin/_common/PageContainer";
import PageHeader from "@/app/admin/_common/PageHeader";
import CuoConfirmDialog from "@/app/admin/_common/CuoConfirmDialog";
import GuestEditDialog from "@/app/admin/_common/guestForm/GuestEditDialog";
import { Users, Trash2 } from "lucide-react";
import { useWaitlistModel } from "./waitlistPageModel";
import WaitlistAnalytics from "./_cmp/waitlist/WaitlistAnalytics";
import WaitlistToolbar from "./_cmp/waitlist/WaitlistToolbar";
import WaitlistTable from "./_cmp/waitlist/WaitlistTable";
import WaitlistCsvUploadDialog from "./_cmp/waitlist/WaitlistCsvUploadDialog";
import WaitlistSizeStat from "./_cmp/waitlist/WaitlistSizeStat";

export default function WaitlistPage() {
  const {
    rows,
    isLoading,
    isLoadingMore,
    hasMore,
    search,
    setSearch,
    filters,
    applyFilters,
    resetFilters,
    loadMore,
    editingGuest,
    setEditingGuest,
    deletingGuest,
    setDeletingGuest,
    csvUploadOpen,
    setCsvUploadOpen,
    handleDelete,
    handleSort,
    sortModel,
    refetch,
  } = useWaitlistModel();

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <PageHeader title="Waitlist" icon={Users} actions={<WaitlistSizeStat />} />

        <div className="flex min-h-0 flex-1 flex-col gap-3 py-5 md:px-5">
          <div className="flex flex-col gap-3 px-3 md:px-0">
            <WaitlistAnalytics />

            <WaitlistToolbar
              search={search}
              onSearchChange={setSearch}
              filters={filters}
              onApplyFilters={applyFilters}
              onResetFilters={resetFilters}
              onOpenCsvUpload={() => setCsvUploadOpen(true)}
            />
          </div>

          <div className="flex min-h-0 flex-1 flex-col">
            <WaitlistTable
              rows={rows}
              isLoading={isLoading}
              isLoadingMore={isLoadingMore}
              hasMore={hasMore}
              onLoadMore={loadMore}
              sortModel={sortModel}
              onSort={handleSort}
              onEdit={setEditingGuest}
              onDelete={setDeletingGuest}
            />
          </div>
        </div>
      </div>

      <WaitlistCsvUploadDialog
        open={csvUploadOpen}
        onClose={() => setCsvUploadOpen(false)}
        getData={refetch}
      />

      <GuestEditDialog
        guest={editingGuest}
        open={!!editingGuest}
        onClose={() => setEditingGuest(null)}
        getData={refetch}
      />

      <CuoConfirmDialog
        open={!!deletingGuest}
        onClose={() => setDeletingGuest(null)}
        title="Delete guest"
        message="Are you sure you want to remove this guest from the waitlist?"
        onConfirm={handleDelete}
        icon={<Trash2 />}
      />
    </PageContainer>
  );
}
